import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const editNotification = async (domain: string, notificationId: number, flowId: number, notificationData: any): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/message/${notificationId}`,
        method: 'PUT',
        params: notificationData,
        headers: {
            "Content-Type": "application/json",
        },
        domain
    });
}